<form [formGroup]="vehicleLocationForm">
    <div
        class="bolt-space-inner-2xl bolt-space-bottom-xl bolt-background-ultralightGray">

        <div class="bolt-row bolt-col-12 bolt-body-copy-lg bolt-space-bottom-xl">Please provide following details to proceed.</div>

        <div class="bolt-row">
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-select label="Country"
                name="country"
                ngDefaultControl
                formControlName="country"
                [attr.error]="formError.checkForError(vehicleLocationForm, 'country')"
                required>
                @for (country of countryOptions; track country) {
                    <option
                    [value]="country.value">{{ country.name }}</option>
                }
                </bolt-select>
            </div>
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-select [label]="stateLabel"
                name="state"
                ngDefaultControl
                formControlName="state"
                [attr.error]="formError.checkForError(vehicleLocationForm, 'state')"
                required>
                @for (state of stateOptions; track state) {
                    <option
                    [value]="state.value">{{ state.name }}</option>
                }
                </bolt-select>
            </div>
        </div>
        <div class="bolt-row">
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-autocomplete label="Address line 1"
                required
                mincharacters="2"
                ngDefaultControl
                name="addressLine1"
                maxlength="60"
                formControlName="addressLine1"
                [attr.error]='formError.checkForError(vehicleLocationForm, "addressLine1")'
                (keyup)="setOptions($event)"
                (change)="setAddressDetails($event)"
                id="vehicleLocationForm_addressLine1TextField">
                </bolt-autocomplete>
            </div>
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-textfield label="Address line 2"
                name="addressLine2"
                maxlength="60"
                ngDefaultControl
                formControlName='addressLine2'
                [attr.error]="formError.checkForError(vehicleLocationForm, 'addressLine2')"></bolt-textfield>
            </div>
        </div>
        <div class="bolt-row">
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-textfield label="City"
                name="city"
                ngDefaultControl
                maxlength="60"
                formControlName='city'
                [attr.error]="formError.checkForError(vehicleLocationForm, 'city')"
                required></bolt-textfield>
            </div>
            <div class="bolt-col-md-6 bolt-col-12 bolt-space-bottom-xl">
                <bolt-textfield [label]="zipCodeLabel"
                required
                name="zipCode"
                ngDefaultControl
                formControlName='zipCode'
                (input)="formatCanadianPostalCode($event)"
                [attr.error]="formError.checkForError(vehicleLocationForm, 'zipCode')">
                </bolt-textfield>
            </div>
        </div>
        <div class="bolt-row">
            <div class="bolt-col-12 bolt-space-bottom-xl">
                <bolt-textfield label="Location description"
                name="locationDescription"
                ngDefaultControl
                maxlength="250"
                formControlName='locationDescription'
                [attr.error]="formError.checkForError(vehicleLocationForm, 'locationDescription')"
                required></bolt-textfield>
            </div>
        </div>
    </div>
</form>
